<template>
  <v-data-table
    class="elevation-1"
    no-data-text="Nenhum agendamento disponível"
    :headers="headers"
    :items="agendamentos"
    :items-per-page="5"
    :footer-props="{
      'items-per-page-text':'Linhas por página',
      'page-text': '{0}-{1} de {2}',
      'items-per-page-all-text': 'Todas',
    }"
  >
    <template #item="{item}">
      <tr
        v-if="statusPermiteEdicao(item)"
        class="tr-bg"
        @click="selecionarAgendamento(item)"
      >
        <td>{{ new Date(item.dataSolicitadaParaAgendamento).toLocaleDateString("pt-br") }}</td>
        <td>{{ new Date(item.dataSolicitadaParaAgendamento).toLocaleTimeString("pt-br", { hour: "2-digit", minute: "2-digit" }) }}</td>
        <td>{{ item.statusNome }}</td>
        <td>{{ item.tipoAgendamentoNome }}</td>
        <td>{{ item.agenteNome }}</td>
      </tr>

      <v-tooltip
        v-else
        top
        color="error"
      >
        <template #activator="{ attrs, on }">
          <tr
            v-bind="attrs"
            v-on="on"
            @click="selecionarAgendamento(item)"
          >
            <td>{{ new Date(item.dataSolicitadaParaAgendamento).toLocaleDateString() }}</td>
            <td>{{ new Date(item.dataSolicitadaParaAgendamento).toLocaleTimeString("pt-br", { hour: "2-digit", minute: "2-digit" }) }}</td>
            <td>{{ item.statusNome }}</td>
            <td>{{ item.tipoAgendamentoNome }}</td>
            <td>{{ item.agenteNome }}</td>
          </tr>
        </template>

        <span>Apenas agendamentos com status "Agendado" podem ser editados</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<style>
.tr-bg {
  /* Set the display to `table-row` because Vuetify makes `flex` */
  display: table-row;
  cursor: pointer;
}

.tr-bg:hover {
  /* `!important` is necessary here because Vuetify overrides this */
  background: grey !important;
}
</style>

<script>
import TicketAgendamentoStatusEnum from '@/models/entities/ticket/TicketAgendamentoStatusEnum'

export default {
  emits: ['selecionar-agendamento'],

  props: {
    agendamentos: {
      type: Array,
      required: true,
    },
  },

  setup(_, { emit }) {
    const headers = [
      { text: 'Data', value: 'dataSolicitadaParaAgendamento' },
      { text: 'Hora', value: 'hora' },
      { text: 'Status', value: 'statusNome' },
      { text: 'Tipo de agendamento', value: 'tipoAgendamentoNome' },
      { text: 'Responsável', value: 'agenteNome' },
    ]

    function statusPermiteEdicao(item) {
      return item.statusId === TicketAgendamentoStatusEnum.Agendado
    }

    function selecionarAgendamento(agendamento) {
      if (!statusPermiteEdicao(agendamento)) return

      emit('selecionar-agendamento', agendamento)
    }

    return {
      headers,
      selecionarAgendamento,
      statusPermiteEdicao,
    }
  },
}
</script>
